import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { RecoverOrphanConfig } from "../../../models/recover-orphan-config";
import { Store } from "../../../services/store.service";

@Component({
  selector: "form-bugs-drawer",
  templateUrl: "./form-bugs-drawer.component.html",
})
export class FormBugsDrawerComponent implements OnChanges {

  @Input() public errors: RecoverOrphanConfig[] = [];
  @Input() public isOpen: boolean = false;
  @Input() public formName: string = "";
  @Output() public closeEvent = new EventEmitter<void>();
  @Output() public focusComponent = new EventEmitter<RecoverOrphanConfig>();

  public subGroups: Map<string, RecoverOrphanConfig[]> = new Map();
  public groupOpen: boolean = true;

  constructor(private store: Store) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.errors || changes.isOpen) {
      this.buildSubGroups();
    }
    if (changes.isOpen && this.isOpen) {
      this.store.state.common.dryRunDrawerOpen = false;
    }
  }

  private buildSubGroups(): void {
    this.subGroups = new Map();
    if (!this.errors || !this.errors.length) {
      return;
    }
    this.errors.forEach((error) => {
      const key = error.parentName || error.objectId || error.parentId || "Unknown";
      if (!this.subGroups.has(key)) {
        this.subGroups.set(key, []);
      }
      this.subGroups.get(key).push(error);
    });
  }

  public onItemClick(mistake: RecoverOrphanConfig): void {
    this.focusComponent.emit(mistake);
  }

  public formatTargetItem(mistake: RecoverOrphanConfig): string {
    if (!mistake.conflictingValue) {
      return mistake.componentKey;
    }
    const conflictedValue = Number(mistake.conflictingValue.replace("-", ""));
    if (!conflictedValue) {
      return mistake.componentKey;
    }
    return conflictedValue.toLocaleString();
  }

  public close(): void {
    this.closeEvent.emit();
  }
}
